import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductsState } from './products.state';

export const selectProductsState = createFeatureSelector<ProductsState>('adminProducts');

export const selectAllProducts = createSelector(
  selectProductsState,
  (state) => state.products,
);

export const selectProductsLoading = createSelector(
  selectProductsState,
  (state) => state.loading,
);

export const selectProductsPagination = createSelector(
  selectProductsState,
  (state) => ({
    total: state.total,
    page: state.page,
    limit: state.limit,
    totalPages: state.totalPages,
  }),
);

export const selectProductsParams = createSelector(
  selectProductsState,
  (state) => state.params,
);

export const selectProductsError = createSelector(
  selectProductsState,
  (state) => state.error,
);
